import { backendApi } from "@/services/backend/api";
import {
  List,
  ServiceObject,
} from "@/services/backend/customers/types/service-object";
import { Filter } from "@/shared/lib/filter/filter";
import { UUID } from "@bitory-gmbh/nidavellir";
import { providesList } from "@/services/backend/_lib/tag-helpers";

const serviceObjectApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    customersServiceObjectPut: build.mutation<ServiceObject, PutRequest>({
      query: (request) => ({
        url: `customers/service-object`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: (_result, _e, request) => [
        { type: "CustomersServiceObject", id: request.id },
        { type: "CustomersServiceObject", id: "LIST" },
      ],
    }),
    customersServiceObjectShow: build.query<ServiceObject, ShowRequest>({
      query: (request) => ({
        url: `customers/service-object`,
        method: "GET",
        params: request,
      }),
      providesTags: (_result, _e, request) => [
        { type: "CustomersServiceObject", id: request.id },
      ],
    }),
    customersServiceObjectList: build.query<List, ListRequest>({
      query: (request) => ({
        url: `customers/service-object/list`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) =>
        providesList(result?.serviceObjects, "CustomersServiceObject"),
    }),
    customersServiceObjectDelete: build.mutation<null, DeleteRequest>({
      query: (request) => ({
        url: `customers/service-object`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: (_result, _e, request) => [
        { type: "CustomersServiceObject", id: request.id },
        { type: "CustomersServiceObject", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useCustomersServiceObjectPutMutation,
  useCustomersServiceObjectShowQuery,
  useCustomersServiceObjectListQuery,
  useCustomersServiceObjectDeleteMutation,
} = serviceObjectApi;

export type PutRequest = ServiceObject;

export interface ShowRequest {
  id: string;
}

export interface ListRequest {
  customer?: Filter<UUID>;
  name?: Filter<string>;
  limit?: number;
  offset?: number;
}

export interface DeleteRequest {
  id: string;
}
